
  import { SmartBannerConfig } from './index'
  export const config: SmartBannerConfig = {
    festivalName: 'La Foire Européenne de Strasbourg',
    appTitle: 'Foire Européenne de Strasbourg',
    appStoreId: '0',
    appleStoreUrl: 'https://apps.apple.com/fr/app/foire-europ%C3%A9enne-de-strasbourg/id1526476572',
    googleStoreUrl: 'https://play.google.com/store/apps/details?id=to.chapi.foireurop&hl=fr',
    appIconUrl: 'https://static.foireurop.chapi.to/app-icon.jpeg',
  }
